import { getBuyerId } from 'dibs-cookie-jar';
import { getDibsSessionId } from 'dibs-cookie-jar/exports/dibsSession.ts';
import { getFullVisitorId } from 'dibs-cookie-jar/exports/fullVisitorId.ts';
import { getTrafficType } from 'dibs-tracking';
import { type RumGlobal } from '@datadog/browser-rum';

/** Consent-gated GA4 join keys. Dealer pages call this directly since they set a seller user. */
export const setDatadogSessionValues = (datadog: RumGlobal): void => {
    const dibsSession = getDibsSessionId();
    if (dibsSession) {
        datadog.setGlobalContextProperty('dibs_session', dibsSession);
    }
    const fullVisitorId = getFullVisitorId();
    if (fullVisitorId) {
        datadog.setGlobalContextProperty('full_visitor_id', fullVisitorId);
    }
};

export const setDatadogUserValues = (datadog: RumGlobal): void => {
    const userId = getBuyerId(document.cookie);
    if (userId) {
        datadog.setUser({ id: userId });
    }
    const trafficType = getTrafficType(document.cookie, new URL(window.location.href));
    if (trafficType) {
        datadog.setGlobalContextProperty('trafficType', trafficType);
    }
    setDatadogSessionValues(datadog);
};
